export default "__VITE_ASSET__CGyGEdd9__"